import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import {
  CLEANUP_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";

const ConfirmModal = ({ handleSubmit, text }) => {
  let navigate = useNavigate();
  // const paramObject = useParams();

  const handleOk = () => {
    // handleCompleteSale();
    handleSubmit();
    // navigate(`/sales-receipt`);
  };

  return (
    <>
      <div
        className="modal fade"
        id="ConfirmModal"
        tabIndex={-1}
        aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p>{text}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleOk();
                }}
              >
                Yes
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                No
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
